<template>
  <span>{{this.countdown.hours}}:{{this.countdown.minutes}}:{{this.countdown.seconds}}</span>
</template>

<script>
export default {
  name: "CountDown",
  props: ["endTime"],
  data() {
    return {
      countdown: ""
    }
  },
  mounted() {
    this.setCountDownInterval(this.endTime * 1000 - new Date().getTime())
  },
  methods: {
    calCountDown(timediff) {
      let seconds = Math.floor((timediff / 1000) % 60)
      let minutes = Math.floor((timediff / 1000 / 60) % 60)
      let hours = Math.floor((timediff / (1000 * 60 * 60)) % 24)
      let countdown = {
        seconds: seconds < 10 ? "0" + (seconds <= 0 ? "0" : seconds) : seconds,
        minutes: minutes < 10 ? "0" + (minutes <= 0 ? "0" : minutes) : minutes,
        hours: hours < 10 ? "0" + (hours <= 0 ? "0" : hours) : hours
      }
      this.countdown = countdown
      return timediff
    },
    setCountDownInterval(timediff) {
      let t = timediff
      this.calCountDown(timediff)
      let intervalTimer = setInterval(() => {
        // 得到剩余时间
        t = t - 1000
        let remainTime = this.calCountDown(t)

        if (remainTime <= 0) {
          clearInterval(intervalTimer)
        }
      }, 1000)
    }
  }
}
</script>
